<template functional>
  <svg
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    :viewBox="$options.iconViewBox(props.icon, props.viewBox)"
    v-on="listeners"
  >
    <path
      v-for="(path, index) in $options.iconPaths(props.icon)"
      :id="path.id"
      :key="index"
      :d="path.d"
      :fill="path.fill"
      :transform="path.transform"
    />
  </svg>
</template>

<script>
import icons from '../../../inline-icons'

const TK_INLINE_ICONS = Object.keys(icons)
const isIcons = (icon) =>
  typeof icon === 'string' ? TK_INLINE_ICONS.includes(icon.trim()) : null

export default {
  name: 'TkSvgIcon',
  inject: {
    components: {
      default: {
        icons,
      },
    },
  },
  props: {
    icon: {
      type: [String, Array],
      default: '',
    },
    viewBox: {
      type: String,
      default: '',
    },
  },
  iconViewBox(icon, viewBox) {
    if (viewBox) {
      return viewBox
    }
    return isIcons(icon) ? icons[icon].viewBox || viewBox : '0 0 24 24'
  },
  iconPaths(icon) {
    if (isIcons(icon)) {
      return icons[icon].paths
    }
    return Array.isArray(icon) ? icon : [icon]
  },
}
</script>
